import angular from 'angular'

import rbvHotelDirectoryRepository from './rbv-ng-hotel-directory.repo';

export default angular.module('rb.rfpHotel.main.rfp.directories', [])
    .service('rbvHotelDirectoryRepository', rbvHotelDirectoryRepository)
    
